import { useEffect } from "react";
import "@/styles/studio.css";
import { useSeo } from "@/lib/site";
import { Cursor } from "@/components/studio/Cursor";
import { Hero } from "@/components/studio/Hero";
import { Portfolio } from "@/components/studio/Portfolio";
import { StudioMarquee, Manifesto, Produce } from "@/components/studio/Sections";
import { Statement } from "@/components/studio/Statement";
import { Beyond, WhyAi, Process, Models } from "@/components/studio/More";
import { Pricing } from "@/components/studio/Pricing";

export default function Studio() {
  useSeo("Perfect Digitals Studio | AI Video Production", "AI video production by Perfect Digitals. Generative AI combined with human creative direction to create complete, brand-ready video productions.");

  useEffect(() => {
    document.documentElement.classList.add("studio-page");
    return () => document.documentElement.classList.remove("studio-page");
  }, []);

  return (
    <div className="studio" style={{ overflowX: "clip" }} data-testid="studio-page">
      <div className="studio-grain" aria-hidden="true" />
      <Cursor />
      <Hero />
      <StudioMarquee />
      <Portfolio />
      <Manifesto />
      <Produce />
      <Statement />
      <Beyond />
      <WhyAi />
      <Process />
      <Models />
      <Pricing />
    </div>
  );
}
